const isChildOf = (node, parentElement) => {
    while (node !== null) {
        if (node === parentElement) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
};
export const getCurrentCursorPosition = (parentElement) => {
    var _a;
    const selection = window.getSelection();
    let offset = -1;
    let node;
    if (selection === null || selection === void 0 ? void 0 : selection.focusNode) {
        if (isChildOf(selection.focusNode, parentElement)) {
            node = selection.focusNode;
            offset = selection.focusOffset;
            while (node) {
                if (node === parentElement) {
                    break;
                }
                if (node.previousSibling) {
                    node = node.previousSibling;
                    offset += ((_a = node.textContent) === null || _a === void 0 ? void 0 : _a.length) || 0;
                }
                else {
                    node = node.parentNode;
                    if (node === null) {
                        break;
                    }
                }
            }
        }
    }
    return offset;
};
const handleTextNode = (node, offset, range) => {
    var _a;
    const nodeTextLength = ((_a = node.textContent) === null || _a === void 0 ? void 0 : _a.length) || 0;
    if (nodeTextLength < offset.count) {
        offset.count -= nodeTextLength;
    }
    else {
        range.setEnd(node, offset.count);
        offset.count = 0;
    }
};
const handleNonTextNodes = (node, offset, range) => {
    for (let i = 0; i < node.childNodes.length; i++) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        range = createRange(node.childNodes[i], offset, range);
        if (offset.count === 0) {
            break;
        }
    }
};
const createRange = (node, offset, range) => {
    if (!range) {
        range = document.createRange();
        range.selectNode(node);
        range.setStart(node, 0);
    }
    if (offset.count === 0) {
        range.setEnd(node, offset.count);
    }
    else if (node && offset.count > 0) {
        if (node.nodeType === Node.TEXT_NODE) {
            handleTextNode(node, offset, range);
        }
        else {
            handleNonTextNodes(node, offset, range);
        }
    }
    return range;
};
export const setCurrentCursorPosition = (offset, element) => {
    if (offset >= 0) {
        const selection = window.getSelection();
        const range = createRange(element, { count: offset });
        if (range) {
            range.collapse(false);
            selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
            selection === null || selection === void 0 ? void 0 : selection.addRange(range);
        }
    }
};
//# sourceMappingURL=CursorService.js.map